import Vue from 'vue'
import Layout from "@/layout/index"
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        name: "登录",
        component: () => import('@/views/login/Login'),
        hidden: true
    },

    {
        path: '/',
        component: Layout,
        redirect: '/home',
        children: [{
            path: '/home',
            name: '首页',
            component: () => import('@/views/Home/Home'),
            meta: {title: '首页', icon: 'el-icon-s-home'}
        }]
    },

    {
        path: '/WeChatMPUserManage',
        component: Layout,
        redirect: '/WeChatMPUserManage',
        name: '用户管理',
        meta: {title: '用户管理', icon: 'el-icon-user'},
        children: [
            {
                path: '/WeChatMPUserManage/MyWeChatMPUserManage',
                name: '微信用户管理',
                component: () => import('@/views/WeChatMPUserManage/MyWeChatMPUserManage'),
                meta: {title: '微信用户管理', icon: 'el-icon-mobile-phone'}
            },
        ]
    },

    {
        path: '/NewsManage',
        component: Layout,
        redirect: '/NewsManage',
        name: '企业总台',
        meta: {title: '企业总台', icon: 'el-icon-s-platform'},
        children: [
            {
                path: '/NewsManage/NewsManage',
                name: '企业管理',
                component: () => import('@/views/NewsManage/NewsManage/NewsManage'),
                meta: {title: '企业管理', icon: 'el-icon-office-building'}
            },
            {
                path: '/AddEditNews/AddEditNews',
                name: '企业编辑',
                component: () => import('@/views/NewsManage/AddEditNews/AddEditNews'),
                hidden: true,
                meta: {title: '企业编辑'}
            },
            {
                path: '/NewsHistory/NewsHistory',
                name: '浏览记录',
                component: () => import('@/views/NewsManage/NewsHistory/NewsHistory'),
                hidden: true,
                meta: {title: '浏览记录'}
            },
            {
                path: '/NewsMessage/NewsMessage',
                name: '企业下单',
                component: () => import('@/views/NewsManage/NewsMessageManage/NewsMessageManage'),
                meta: {title: '企业下单', icon: 'el-icon-s-order'}
            },
            {
                path: '/CameraManage/CameraManage',
                name: '摄像头管理',
                component: () => import('@/views/NewsManage/CameraManage/CameraManage'),
                meta: {title: '摄像头管理', icon: 'el-icon-user-solid'}
            },
        ]
    },

    {
        path: '/StoreManage',
        component: Layout,
        redirect: '/StoreManage',
        name: '商城管理',
        meta: {title: '商城管理', icon: 'el-icon-goods'},
        children: [
            {
                path: '/StoreShopManage/StoreShopManage',
                name: '店铺管理',
                component: () => import('@/views/StoreManage/StoreShopManage/StoreShopManage'),
                meta: {title: '店铺管理', icon: 'el-icon-s-shop'}
            },
            {
                path: '/StoreTypeManage/StoreTypeManage',
                name: '商品类型',
                component: () => import('@/views/StoreManage/StoreTypeManage/StoreTypeManage'),
                hidden: true,
                meta: {title: '商品类型', icon: 'el-icon-collection-tag'}
            },
            {
                path: '/StoreProductManage/StoreProductManage',
                name: '商品管理',
                component: () => import('@/views/StoreManage/StoreProductManage/StoreProductManage'),
                hidden: true,
                meta: {title: '商品管理', icon: 'el-icon-goods'}
            },
            {
                path: '/StoreOrderManage/StoreOrderManage',
                name: '订单管理',
                component: () => import('@/views/StoreManage/StoreOrderManage/StoreOrderManage'),
                meta: {title: '订单管理', icon: 'el-icon-s-order'}
            },
        ]
    },

    {
        path: '/MapMarkerManage',
        component: Layout,
        redirect: '/MapMarkerManage',
        name: '地图标记管理',
        meta: {title: '地图标记管理', icon: 'el-icon-location-outline'},
        children: [
            {
                path: '/MapMarkerManage/MapMarkerManage',
                name: '地图标记管理',
                component: () => import('@/views/MapMarkerManage/MapMarkerManage/MapMarkerManage'),
                meta: {title: '地图标记管理', icon: 'el-icon-location-outline'}
            },
        ]
    },

    {
        path: '/CustomerMessageManage',
        component: Layout,
        redirect: '/CustomerMessageManage',
        name: '客户消息',
        meta: {title: '客户消息', icon: 'el-icon-chat-line-round'},
        hidden: true,
        children: [
            {
                path: '/CustomerMessageManage/CustomerMessageManage',
                name: '客户消息',
                component: () => import('@/views/CustomerMessageManage/CustomerMessageManage'),
                meta: {title: '客户消息', icon: 'el-icon-chat-line-round'},
            },
        ]
    },

    // {
    //     path: '/LogisticsManage',
    //     component: Layout,
    //     redirect: '/LogisticsManage',
    //     name: '物流管理',
    //     meta: {title: '物流管理', icon: 'el-icon-user-solid'},
    //     children: [
    //         {
    //             path: '/LogisticsManage/LogisticsManage',
    //             name: '物流管理',
    //             component: () => import('@/views/LogisticsManage/LogisticsManage/LogisticsManage'),
    //             meta: {title: '物流管理', icon: 'el-icon-user-solid'}
    //         },
    //         {
    //             path: '/AddEditLogisticsStart/AddEditLogisticsStart',
    //             name: '物流起点编辑',
    //             component: () => import('@/views/LogisticsManage/AddEditLogisticsStart/AddEditLogisticsStart'),
    //             hidden: true,
    //             meta: {title: '物流起点编辑'}
    //         },
    //         {
    //             path: '/LogisticsMessage/LogisticsMessage',
    //             name: '物流下单',
    //             component: () => import('@/views/LogisticsManage/LogisticsMessageManage/LogisticsMessageManage'),
    //             meta: {title: '物流下单', icon: 'el-icon-user-solid'}
    //         },
    //     ]
    // },

    // {
    //     path: '/ChildrenManage',
    //     component: Layout,
    //     redirect: '/ChildrenManage',
    //     name: '子账号管理',
    //     children: [
    //         {
    //             path: '/ChildrenManage/ChildrenManage',
    //             name: '子账号管理',
    //             component: () => import('@/views/ChildrenManage/ChildrenManage/ChildrenManage'),
    //             hidden: true,
    //             meta: {title: '子账号管理'}
    //         },
    //         {
    //             path: '/ChildrenManage/AuditManage',
    //             name: '审核员管理',
    //             component: () => import('@/views/ChildrenManage/AuditManage/AuditManage'),
    //             hidden: true,
    //             meta: {title: '审核员管理'}
    //         },
    //     ],
    // },

    {
        path: '/MerchantManage',
        component: Layout,
        redirect: '/MerchantManage',
        name: '合伙人管理',
        meta: {title: '合伙人管理', icon: 'el-icon-s-custom'},
        children: [
            {
                path: '/MerchantManage/MerchantManage',
                name: '合伙人入驻',
                component: () => import('@/views/MerchantManage/MerchantManage'),
                meta: {title: '合伙人入驻', icon: 'el-icon-s-check'},
            },
            {
                path: '/MerchantNewsManage/MerchantNewsManage',
                name: '合伙人企业',
                component: () => import('@/views/MerchantManage/MerchantNewsManage/MerchantNewsManage'),
                meta: {title: '合伙人企业', icon: 'el-icon-office-building'},
            },
            {
                path: '/CheckMerchantNewsManage/CheckMerchantNewsManage',
                name: '审核合伙人企业',
                component: () => import('@/views/MerchantManage/CheckMerchantNewsManage/CheckMerchantNewsManage'),
                hidden: true,
                meta: {title: '审核合伙人企业'}
            },
            {
                path: '/ChatGroupManage/ChatGroupManage',
                name: '群聊管理',
                component: () => import('@/views/MerchantManage/ChatGroupManage/ChatGroupManage'),
                meta: {title: '群聊管理', icon: 'el-icon-chat-line-square'},
            },
        ]
    },

];

const router = new VueRouter({
    routes,
    mode: 'history',
});

export default router;
